import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useFranchises } from "../../hooks/UseFranchises";

export function EditSerialFranchise({ user, serialId }) {
    const [searchQuery, setSearchQuery] = useState("");
    const [foundFranchises, setFoundFranchises] = useState([]);
    const [currentFranchise, setCurrentFranchise] = useState(null);
    const [loading, setLoading] = useState(false);
    const fHook = useFranchises();

    useEffect(() => {
        fHook.getBySerialId(user.token, serialId).then(data => {
            if (data) setCurrentFranchise(data);
        });
    }, [serialId]);

    const handleSearch = async (query) => {
        setSearchQuery(query);
        if (query.length > 2) {
            const results = await fHook.loadAll(user.token, 10, 0, query);
            setFoundFranchises(results || []);
        } else {
            setFoundFranchises([]);
        }
    };

    const onAdd = async (franchise) => {
        setLoading(true);
        try {
            // 1. Looking for how many serials
            const existing = await fHook.getSerials(user.token, franchise.id);
            const nextOrder = existing.length > 0
                ? Math.max(...existing.map(s => s.orderIndex || 0)) + 1
                : 0;

            // 2. Adding
            const ok = await fHook.addSerial(user.token, franchise.id, serialId, nextOrder);
            if (ok) {
                setCurrentFranchise(franchise);
                setSearchQuery("");
                setFoundFranchises([]);
            }
        } catch (e) {
            alert("Помилка при додаванні");
        } finally {
            setLoading(false);
        }
    };

    const onRemove = async () => {
        if (!window.confirm("Видалити серіал із франшизи?")) return;
        setLoading(true);
        const ok = await fHook.removeSerial(user.token, currentFranchise.id, serialId);
        if (ok) setCurrentFranchise(null);
        setLoading(false);
    };

    return (
        <div>
            {currentFranchise ? (
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '12px',
                    background: '#f8fafc',
                    border: '1px solid #e2e8f0',
                    borderRadius: '8px'
                }}>
        <span>
            ⛓️ Франшиза: {" "}
            <Link
                to={`/franchises/edit?id=${currentFranchise.id}`}
                style={{
                    color: '#4f46e5',
                    fontWeight: 'bold',
                    textDecoration: 'none',
                    borderBottom: '1px dashed #4f46e5'
                }}
                onMouseOver={(e) => e.target.style.color = '#3730a3'}
                onMouseOut={(e) => e.target.style.color = '#4f46e5'}
            >
                {currentFranchise.name}
            </Link>
        </span>

                    <button
                        onClick={onRemove}
                        disabled={loading}
                        style={{
                            color: '#ef4444',
                            background: 'none',
                            border: '1px solid #fee2e2',
                            padding: '5px 10px',
                            borderRadius: '6px',
                            cursor: 'pointer'
                        }}
                    >
                        {loading ? '...' : 'Видалити'}
                    </button>
                </div>
            ) : (
                <div style={{ position: 'relative' }}>
                    <input
                        type="text"
                        placeholder="🔍 Пошук франшизи..."
                        value={searchQuery}
                        onChange={(e) => handleSearch(e.target.value)}
                        style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #d1d5db', boxSizing: 'border-box' }}
                    />
                    {foundFranchises.length > 0 && (
                        <div style={{ position: 'absolute', width: '100%', background: 'white', border: '1px solid #ccc', borderRadius: '8px', zIndex: 100, marginTop: '5px' }}>
                            {foundFranchises.map(f => (
                                <div key={f.id} onClick={() => onAdd(f)} style={{ padding: '10px', cursor: 'pointer', borderBottom: '1px solid #eee' }} onMouseOver={e => e.target.style.background = '#f1f5f9'} onMouseOut={e => e.target.style.background = 'white'}>
                                    ➕ {f.name}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}